import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import title from './Title.module.css';
import { Link } from 'react-router-dom';


function Title() {
    return (
        <Container fluid>            
            <Row xs={1} md={2}>                
                <Col className="p-0">                    
                    <div id={title.myleft}>                        
                        <div id={title.titleabout} className="centre">                            
                            <h1>
                                <Link to="/about" style={{ textDecoration: 'none', color: 'inherit' }}><span>PHOENIX OBJECT CONSERVATION</span></Link>
                            </h1>
                            <Link to="/portfolio" style={{ textDecoration: 'none', color: 'inherit' }}>
                                <div className="font_didot_20">
                                    View My Work
                                </div>
                            </Link>                            
                        </div>
                    </div>                
                </Col>
                <Col className="p-0">
                    <figure>
                        <div id={title.svgcontainer}>
                            <svg id={title.logosvg} viewBox="0 0 700 650">
                                <g>
                                    <path d="M537 279c6,-13 15,-23 28,-27 0,-4 -5,-6 -15,-5 15,-13 30,-16 46,-18 -7,-18 -4,-36 9,-55 3,18 10,35 25,48 0,-8 3,-16 12,-25 -4,1 -4,32 5,34 4,2 23,9 29,25 18,11 24,19 22,32 -8,-8 -18,-19 -29,-20 -22,-8 -57,-14 -75,-3 -18,11 -7,58 -12,87 -4,29 -13,78 -59,97 -133,56 -79,92 -139,140 -36,29 -86,43 -133,33 -52,-12 -86,-66 -141,-70 0,0 49,-4 116,28 67,33 125,6 147,-18 22,-24 44,-76 44,-76 -35,4 -57,24 -77,43 -25,24 -60,44 -105,27 46,3 60,-16 66,-19 41,-20 50,-63 115,-84 -26,-9 -62,-28 -106,15 9,-20 31,-67 96,-55 33,5 91,13 115,-18 -25,11 -50,15 -78,2 17,-1 30,-1 43,-8 18,-10 36,-31 14,-33 -13,11 -33,22 -58,21 -15,18 -50,48 -98,-6 40,17 64,16 88,5 -12,-3 -26,-8 -40,-17 -25,9 -59,9 -99,-25 66,20 98,14 139,-6 0,0 -11,15 -30,26 36,8 61,7 86,-2 12,-13 38,-46 -12,-45 -12,1 -28,9 -43,19 8,-15 17,-27 36,-35 -10,-13 -28,-13 -48,-8 7,-11 19,-16 36,-15 -13,-8 -28,-13 -45,-16 8,-4 18,-7 30,-6 -36,-30 -47,-71 -44,-117 14,49 33,77 58,87 -39,-47 -46,-99 -14,-155 -9,47 -1,92 28,133 -12,-26 -16,-54 -1,-83 -3,28 -1,68 38,102 31,36 30,66 30,66zm67 -100c3,8 3,21 12,31 9,10 9,11 9,11 -8,-5 -18,-3 -19,-8l-2 -34zm-489 303c53,1 72,-48 140,-17 32,15 49,21 95,5 -47,52 -80,34 -123,17 -37,-15 -60,24 -112,-5zm284 -453c-30,62 -29,95 -16,139 0,0 -67,-66 16,-139zm-30 248c29,20 54,18 82,13 0,0 -62,50 -82,-13zm-20 -62c21,38 42,47 78,52 0,0 -83,22 -78,-52zm-3 -81c24,65 47,88 88,109 0,0 -94,1 -88,-109zm131 -134c-52,46 -64,76 -68,122 0,0 -37,-87 68,-122zm-253 551c0,0 -62,-22 -92,-22 -29,0 -53,27 -78,30 -24,4 -54,-7 -54,-7 0,0 33,4 55,-15 23,-19 57,-37 87,-26 29,11 82,40 82,40zm410 -318c0,0 14,3 18,6 3,4 3,6 3,6 0,0 -12,-1 -21,-12z" fill="#0497B0">
                                    </path>
                                </g>
                            </svg>
                        </div>                        
                    </figure>
                </Col>
            </Row>                       
        </Container>        
    );
}

export default Title;
